import { MapPin, Phone, Smartphone, Mail, Clock, MessageCircle, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";
import { STORES, waStore } from "../../lib/site";

const StoreInfo = ({ store, i }) => (
  <div className="rounded-3xl bg-[#FAFAFA] border border-neutral-100 p-8 md:p-10 h-full flex flex-col">
    <h3 className="font-display font-bold text-2xl">{store.name}</h3>
    {store.person && (
      <p className="mt-2 text-sm text-neutral-500">Referente in negozio: <span className="font-semibold text-brand">{store.person}</span></p>
    )}
    {store.comingSoon && (
      <span className="mt-3 inline-flex w-fit items-center gap-2 rounded-full bg-brand/10 border border-brand/30 text-brand text-sm font-semibold px-4 py-1.5">
        <Sparkles className="w-4 h-4" /> {store.comingSoon}
      </span>
    )}
    <ul className="mt-6 space-y-6">
      <li className="flex gap-4">
        <span className="w-11 h-11 rounded-2xl bg-brand-soft flex items-center justify-center shrink-0"><MapPin className="w-5 h-5 text-brand" /></span>
        <div>
          <p className="text-xs uppercase tracking-widest text-neutral-400 font-bold">Indirizzo</p>
          <p className="font-semibold text-lg">{store.address}</p>
        </div>
      </li>
      {store.phone && (
        <li className="flex gap-4">
          <span className="w-11 h-11 rounded-2xl bg-brand-soft flex items-center justify-center shrink-0"><Phone className="w-5 h-5 text-brand" /></span>
          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-400 font-bold">Telefono</p>
            <a href={`tel:${store.phone.tel}`} data-testid={`contact-phone-primary-${i}`} className="font-semibold text-lg hover:text-brand transition-colors">{store.phone.label}</a>
          </div>
        </li>
      )}
      {store.mobile && (
        <li className="flex gap-4">
          <span className="w-11 h-11 rounded-2xl bg-brand-soft flex items-center justify-center shrink-0"><Smartphone className="w-5 h-5 text-brand" /></span>
          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-400 font-bold">Cellulare / WhatsApp</p>
            <a href={`tel:${store.mobile.tel}`} data-testid={`contact-phone-mobile-${i}`} className="font-semibold text-lg hover:text-brand transition-colors">{store.mobile.label}</a>
          </div>
        </li>
      )}
      {store.email && (
        <li className="flex gap-4">
          <span className="w-11 h-11 rounded-2xl bg-brand-soft flex items-center justify-center shrink-0"><Mail className="w-5 h-5 text-brand" /></span>
          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-400 font-bold">Email</p>
            <a href={`mailto:${store.email}`} data-testid={`contact-email-${i}`} className="font-semibold text-lg hover:text-brand transition-colors break-all">{store.email}</a>
          </div>
        </li>
      )}
      {store.hours && (
        <li className="flex gap-4">
          <span className="w-11 h-11 rounded-2xl bg-brand-soft flex items-center justify-center shrink-0"><Clock className="w-5 h-5 text-brand" /></span>
          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-400 font-bold">Orari</p>
            <ul className="mt-1 space-y-1">
              {store.hours.map((h) => (
                <li key={h.day} className="flex flex-col sm:flex-row sm:gap-3">
                  <span className="font-semibold w-40">{h.day}</span>
                  <span className={h.closed ? "text-neutral-400" : "text-neutral-600"}>{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </li>
      )}
    </ul>

    {!store.comingSoon && (
      <a href={waStore(store)} target="_blank" rel="noreferrer" data-testid={`contact-whatsapp-btn-${i}`}
        className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-brand hover:bg-brand-hover text-white px-7 py-3.5 font-semibold transition-all duration-200 hover:scale-[1.03]">
        <MessageCircle className="w-5 h-5" /> Richiedi una consulenza gratuita
      </a>
    )}
  </div>
);

export const Contacts = () => (
  <section id="contatti" data-testid="contacts-section" className="bg-white py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-brand">Contatti</p>
        <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-3 max-w-2xl">
          Vieni a trovarci nei nostri negozi
        </h2>
      </Reveal>

      <div className="mt-14 space-y-6">
        {STORES.map((store, i) => (
          <Reveal key={store.id} delay={0.05}>
            <div data-testid={`store-${store.id}`} className="grid lg:grid-cols-2 gap-6">
              <StoreInfo store={store} i={i} />
              <div className="rounded-3xl overflow-hidden border border-neutral-100 h-full min-h-[24rem]">
                <iframe
                  title={`Mappa ${store.name}`}
                  data-testid={`google-map-${i}`}
                  src={`https://www.google.com/maps?q=${encodeURIComponent(store.mapsQuery)}&output=embed`}
                  className="w-full h-full min-h-[24rem]"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
